import React from 'react';
import { TrendingUp, Target, DollarSign } from 'lucide-react';
import { mockCaseStudies } from '../data/mock';

const CaseStudies = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: "'Crimson Text', serif" }}>
            Success Stories
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Real results from real businesses. See how we've helped companies achieve remarkable growth.
          </p>
        </div>

        <div className="space-y-12">
          {mockCaseStudies.map((study, index) => (
            <div 
              key={study.id}
              className="bg-white rounded-xl p-8 md:p-12 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-200 hover:border-black"
            >
              <div className="grid md:grid-cols-3 gap-8">
                {/* Left Column - Details */}
                <div className="md:col-span-2 space-y-6">
                  <div>
                    <span className="inline-block px-4 py-1 bg-black text-white text-sm font-semibold rounded-full mb-4">
                      {study.industry}
                    </span>
                    <h3 className="text-3xl font-bold mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>
                      {study.title}
                    </h3>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-2 text-gray-900">Challenge</h4>
                    <p className="text-gray-700 leading-relaxed">{study.challenge}</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-2 text-gray-900">Solution</h4>
                    <p className="text-gray-700 leading-relaxed">{study.solution}</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg mb-3 text-gray-900">Key Results</h4>
                    <ul className="space-y-2">
                      {study.results.map((result, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-black rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-gray-700">{result}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="pt-2">
                    <span className="text-sm text-gray-600">
                      <strong>Duration:</strong> {study.duration}
                    </span>
                  </div>
                </div>

                {/* Right Column - Metrics */}
                <div className="bg-[#ECEC75] rounded-xl p-6 flex flex-col justify-center space-y-6">
                  <h4 className="font-semibold text-lg text-center" style={{ fontFamily: "'Crimson Text', serif" }}>
                    Impact Metrics
                  </h4>
                  
                  {Object.entries(study.metrics).map(([key, value], idx) => {
                    const icons = [TrendingUp, Target, DollarSign];
                    const Icon = icons[idx % icons.length];
                    return (
                      <div key={key} className="text-center">
                        <div className="inline-flex items-center justify-center w-12 h-12 bg-black rounded-full mb-3">
                          <Icon className="h-6 w-6 text-white" />
                        </div>
                        <div className="text-4xl font-bold mb-1" style={{ fontFamily: "'Crimson Text', serif" }}>
                          {value}
                        </div>
                        <div className="text-sm text-gray-700 capitalize">
                          {key.replace(/([A-Z])/g, ' $1').trim()}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
